import * as React from "react";
import { cn } from "../../lib/utils";

interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "default" | "md" | "lg" | "xl";
}

export function Avatar({ className, size = "default", ...props }: AvatarProps) {
  const sizeClasses = {
    sm: "size-6",
    default: "size-8",
    md: "size-10",
    lg: "size-12",
    xl: "size-16",
  };

  return (
    <div
      className={cn(
        "relative flex shrink-0 overflow-hidden rounded-full",
        sizeClasses[size],
        className
      )}
      {...props}
    />
  );
}

interface AvatarImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallback?: string;
}

export function AvatarImage({ className, fallback = '/blank_portait.png', src, ...props }: AvatarImageProps) {
  const [imgSrc, setImgSrc] = React.useState(src);

  React.useEffect(() => {
    setImgSrc(src);
  }, [src]);

  return (
    <img
      src={imgSrc}
      onError={() => setImgSrc(fallback)}
      className={cn("aspect-square size-full object-cover", className)}
      {...props}
    />
  );
}